import { TelemetryGridFilterConfiguration } from '../../../wlm-filters/telemetry-filter/telemetry-filter-configuration';

export class SATelemetrySelectorSettings {
  telemetryFilterSettings: TelemetryGridFilterConfiguration;
  serviceName?: string;
  constructor(init?: SATelemetrySelectorSettings) {
    Object.assign(this, init);
  }
}
